import { useEffect, useState } from 'react';
import { Button, Form, Input, InputNumber, Popconfirm, Radio, message } from 'antd';
import moment from 'moment';
import { createAdjustment, getAdjustments } from '@gtintel/platform-api';
import { AdjustmentType } from '@gtintel/platform-types';
import AddAdjustment from './AddAdjustment';
const defaultAdjustment = {
  adjustment_type: AdjustmentType.client_price,
  amount: 0,
  reason: '',
  actor: 'You'
};
const Adjustments = ({
  project
}) => {
  const [adjustments, setadjustments] = useState([]);
  const [allAdjustments, setAllAdjustments] = useState([]);
  const [adjustmentToAdd, setadjustmentToAdd] = useState(defaultAdjustment);
  useEffect(() => {
    if (adjustmentToAdd.amount != 0) {
      setAllAdjustments([...adjustments, adjustmentToAdd]);
    } else {
      setAllAdjustments(adjustments);
    }
  }, [adjustments, adjustmentToAdd]);
  useState(() => {
    getAdjustments(project.id).then(changes => setadjustments(changes.results)).catch(() => {});
  });
  const [form] = Form.useForm();
  const submitAdjustment = () => {
    createAdjustment(project.id, adjustmentToAdd).then(() => {
      setadjustmentToAdd({
        ...defaultAdjustment,
        adjustment_type: adjustmentToAdd.adjustment_type
      });
      form.resetFields();
      getAdjustments(project.id).then(changes => setadjustments(changes.results), message.success('Adjustment added!')).catch(error => {
        message.error(error.message);
      });
    }).catch(() => {});
  };
  return <>
      <Form form={form} layout="inline" size="small">
        <Form.Item name="Type" label="Type" rules={[{
        required: true
      }]}>
          <Radio.Group options={[{
          label: 'Client',
          value: AdjustmentType.client_price
        }, {
          label: 'Partner',
          value: AdjustmentType.partner_price
        }]} onChange={e => setadjustmentToAdd({
          ...adjustmentToAdd,
          adjustment_type: e.target.value
        })} value={adjustmentToAdd.adjustment_type} defaultValue={adjustmentToAdd.adjustment_type} optionType="button" />
        </Form.Item>
        <Form.Item name="Amount" label="Amount" rules={[{
        required: true
      }]}>
          <InputNumber formatter={value => `${project.currency} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} value={adjustmentToAdd?.amount} onChange={value => setadjustmentToAdd({
          ...adjustmentToAdd,
          amount: value ?? 0
        })} />
        </Form.Item>
        <Form.Item name="Reason" label="Reason" rules={[{
        required: true
      }]}>
          <Input value={adjustmentToAdd?.reason} onChange={e => setadjustmentToAdd({
          ...adjustmentToAdd,
          reason: e.target.value
        })} />
        </Form.Item>
        <Form.Item>
          <Popconfirm placement="topLeft" title="Are you sure?" onConfirm={submitAdjustment} okText="Yes" cancelText="No">
            <Button type="primary" htmlType="submit">
              Add
            </Button>
          </Popconfirm>
        </Form.Item>
      </Form>
      {adjustmentToAdd.adjustment_type === AdjustmentType.client_price && <AddAdjustment adjustments={allAdjustments.filter(adjustment => adjustment.adjustment_type === AdjustmentType.client_price)} originalPrice={+project.final_price} projectCreatedDate={moment(project.created_date).toDate()} currency={project.currency} />}
      {adjustmentToAdd.adjustment_type === AdjustmentType.partner_price && <AddAdjustment adjustments={allAdjustments.filter(adjustment => adjustment.adjustment_type === AdjustmentType.partner_price)} originalPrice={+project.partner_price} projectCreatedDate={moment(project.created_date).toDate()} currency={project.currency} />}
    </>;
};
export default Adjustments;